import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

// iOS MetaFeedOutfitCell: CLICK_CONTENT (셀 탭 시)
export const logOnPressContent = (logging: IScreensLogging) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_CONTENT',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};